import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = { resourceId: Number }

  connect() {
    this.interval = setInterval(() => {
      this.autoSave();
    }, 5000);
  }

  disconnect() {
    clearInterval(this.interval);
  }

  manualSave(event){
    event.preventDefault();
    this.manualSubmitForm(`/course_completion_test_take_exams/examination_manual_update/${this.resourceIdValue}`)
  }

  autoSave() {
    this.autoSubmitForm(`/course_completion_test_take_exams/examination_auto_update/${this.resourceIdValue}`)
  }

  manualSubmitForm(url) {
    const formData = new FormData(this.formTarget);
    const csrfToken = document.querySelector("[name='csrf-token']").content;
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    }).then(response => response.json())
      .then(data => {
        if(data.redirect_url) {
          window.location.href = data.redirect_url;
        }
    })
  }

  autoSubmitForm(url) {
    const formData = new FormData(this.formTarget);
    const csrfToken = document.querySelector("[name='csrf-token']").content;
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    })
  }
}
